import { IShip } from '../../../data/types/ship/ship';
import { getShipConfig } from '../../../config/ship/get-ship-config';

export const hasEmptyCrewCabines = (ship: IShip): boolean =>
  getShipConfig(ship).crewCabines > ship.crew.length;
